<template>
  <ul class="property-table-container">
    <li>
      <span class="header property-table--sort" @click="sort({ type: 'id' })"
        >ID
        <LsIcon
          class="property-table-mobile--sort-icon"
          :type="getIconValues('id').type"
          :color="getIconValues('id').color"
      /></span>
      <span class="header property-table--sort" @click="sort({ type: 'address' })"
        >Address
        <LsIcon
          class="property-table-mobile--sort-icon"
          :type="getIconValues('address').type"
          :color="getIconValues('address').color"
        />
      </span>
      <span class="header">Status</span> <span class="header">Next Service</span>
      <span class="header" test-id="needed-for-spacing"></span>
    </li>
    <li
      v-for="(section, idx) in properties"
      :key="section.property.id"
      tabIndex="0"
      :test-id="`row-${idx + 1}`"
      @mousedown="$event.preventDefault()"
      @mouseup="navToMyServices({ propertyID: section.property.id })"
      @keyup="navToMyServices({ propertyID: section.property.id }, $event)"
    >
      <span>{{ section.property.id }}</span> <span>{{ getFullAddress(section.property) }}</span>
      <span :class="section.details.class"> {{ section.details.status }} </span>
      <span v-if="section.details.nextMow"> {{ section.details.nextMow | date('compact') }} </span>
      <span v-else> No upcoming service </span>
      <LsIcon type="chevron" size="md" class="property-table--chevron" />
    </li>
  </ul>
</template>

<script>
import VueTypes from 'vue-types';
import { LsIcon } from '@/components/common';
import { lsPropTypeHelpers } from 'ls-vue-common';
import { getSortingIconValues } from '../property-table.helpers';

export default {
  name: 'PropertyTable',
  components: {
    LsIcon,
  },
  props: {
    properties: VueTypes.arrayOf(
      VueTypes.shape({
        property: VueTypes.shape({
          id: VueTypes.number.isRequired,
          street: VueTypes.string.isRequired,
          city: VueTypes.string.isRequired,
          state: VueTypes.string.isRequired,
          zip: VueTypes.string.isRequired,
        }).isRequired.loose,
        details: VueTypes.shape({
          class: VueTypes.string.isRequired,
          status: VueTypes.string.isRequired,
          nextMow: VueTypes.custom(lsPropTypeHelpers.stringOrNull),
        }).isRequired.loose,
      })
    ).isRequired,
    navToMyServices: VueTypes.func.isRequired,
    sort: VueTypes.func.isRequired,
    sorting: VueTypes.shape({
      type: VueTypes.string.isRequired,
      order: VueTypes.string.isRequired,
    }),
  },
  methods: {
    getFullAddress(property) {
      const { street, city, state, zip } = property;

      return `${street}, ${city}, ${state} ${zip}`;
    },
    getIconValues(type) {
      return getSortingIconValues({ sorting: this.sorting, type });
    },
  },
};
</script>

<style lang="scss" scoped>
.property-table-container {
  display: table;
  width: 100%;
  border-collapse: collapse;
  list-style: none;

  .property-table--sort {
    cursor: pointer;
    user-select: none;
  }

  .property-table-mobile--sort-icon {
    transform: translateY(1px);
  }

  > li {
    display: table-row;
    border-bottom: 1px solid $primary-light;
    outline: none;

    &:not(:first-child) {
      cursor: pointer;
      &:hover,
      &:focus {
        background-color: rgb(245, 245, 245);
      }
    }

    > span {
      padding: 16px 0;
      display: table-cell;

      &.header {
        font-weight: bold;
      }

      &.active {
        color: $primary;
      }

      &.inactive {
        color: $danger;
      }

      &.cancelled {
        color: $danger;
      }

      &.paused {
        color: $tertiary;
      }

      &:first-child {
        padding-left: 10px;
      }

      &:nth-child(1) {
        width: 15%;
      }
      &:nth-child(2) {
        width: 45%;
      }
      &:nth-child(3) {
        width: 20%;
      }
      &:nth-child(4) {
        width: 20%;
      }
    }

    .property-table--chevron {
      transform: translateY(6px);
    }
  }
}
.themed-app {
  .property-table-container {
    > li {
      border-color: $theme-color-primary-light;
      > span {
        &.active {
          color: $theme-color-primary;
        }

        &.inactive {
          color: $theme-color-danger;
        }

        &.cancelled {
          color: $theme-color-danger;
        }

        &.paused {
          color: $theme-color-secondary;
        }
      }
    }
  }
}
</style>
